<template>
	<div class="tab-table-wrapper">
		<!-- 只有在 MenuList 里存在的才显示 -->
		<div class="tab-list">
			<el-button v-for="item in authorizedTabs" :key="item.value"
				:type="activeTab === item.value ? 'primary' : 'default'" @click="handleTabChange(item.value)">
				{{ item.label }}
			</el-button>
		</div>

		<!-- 只渲染有权限的组件 -->
		<div class="tab-content" v-if="activeTab">
			<component :is="activeTab" :key="activeTab" @forActiveTab="forActiveTab" />
		</div>
	</div>
</template>

<script>
	// 你的组件
	import ModelKeyTable from '../../admin/manage/ModelManage/components/ModelKey.vue'
	import ModelKeyShare from '../../admin/manage/ModelManage/components/ModelKeyShare.vue'
	import WorkflowTable from '../../admin/manage/ModelManage/components/Workflow.vue'
	import StandardCourseManagement from '../../admin/manage/CourseManage/StandardCourseManagement.vue'
	import MonitorWork from '../../admin/manage/ModelManage/components/MonitorWork.vue'


	export default {
		name: 'TabTableContainer',
		components: {
			schoolModelKey: ModelKeyTable,
			schoolModeManagement: WorkflowTable,
			modelKeyShare: ModelKeyShare,
			schoolStandardCourseManagement: StandardCourseManagement,
			monitorWork: MonitorWork,
		},
		data() {
			return {
				tabs: [{
						label: '密钥配置',
						value: 'schoolModelKey'
					},
					{
						label: '共享密钥',
						value: 'modelKeyShare'
					},
					{
						label: '标准智能体配置',
						value: 'schoolModeManagement'
					},
					{
						label: '标准课程管理',
						value: 'schoolStandardCourseManagement'
					},
					{
						label: '敏感词管理',
						value: 'monitorWork'
					},
				],
				activeTab: ''
			}
		},
		computed: {
			// 从 localStorage 读取菜单权限
			menuList() {
				try {
					return localStorage.getItem('MenuList') || ''
				} catch (e) {
					return ''
				}
			},

			// 核心：只保留 MenuList 中存在的 tab
			authorizedTabs() {
				return this.tabs.filter(tab => {
					return this.menuList.includes(tab.value)
				})
			}
		},
		created() {
			
			if(this.$route.query?.activeTab){
				this.initTabFromRoute()
			}else{
				this.setDefaultTab()
			}
		},
		watch: {
			// 监听路由变化（其他页面跳转带activeTab进来）
			// '$route.query.activeTab'(newVal) {
			// 	if (newVal) {
			// 		this.setTabAndClearParam(newVal)
			// 	}
			// }
		},
		methods: {
			forActiveTab(val){
				if(val === 2||val === 3||val===4||val===5){
				  // 1. 先修改v-model绑定的activeTab，UI标签才会真正切换
				  this.handleTabChange("schoolModeManagement")
				  // nextTick 等DOM渲染完成，ref已经可用，再去刷新子组件
				
				}
			},
			initTabFromRoute() {
				const routeTab = this.$route.query.activeTab
				if (routeTab) {
					this.setTabAndClearParam(routeTab)
				} else {
					// 无参数走默认第一个
					this.setDefaultTab()
				}
			},
			// 设置activeTab + 删除url上的activeTab参数
			setTabAndClearParam(tabValue) {
			  // 判断该tab是否有权限
			  const targetTab = this.authorizedTabs.find(item => item.value === tabValue)
			  if (targetTab) {
			    this.activeTab = tabValue
			  } else {
			    this.setDefaultTab()
			  }
			
			  // 1. 拷贝原有query，移除activeTab
			  const newQuery = { ...this.$route.query }
			  delete newQuery.activeTab // 关键：先删再传，不是等回调删
			
			  // 2. 只传清理后的query，path省略会复用当前路径，hash模式更稳定
			  this.$router.replace({
			    query: newQuery
			  })
			},
			handleTabChange(value) {
				this.activeTab = value
			},
			// 默认选中第一个有权限的
			setDefaultTab() {
				if (this.authorizedTabs.length > 0) {
					this.activeTab = this.authorizedTabs[0].value
				}
			}
		}
	}
</script>

<style scoped>
	.tab-table-wrapper {
		width: 100%;
		padding: 12px;
	}

	.tab-list {
		display: flex;
		gap: 0px;
		margin-bottom: 15px;
	}

	.tab-content {
		width: 100%;
	}
</style>